import { formatCurrency0 } from '@/features/league/_shared/stats'

/** Whole-dollar salary; null/unset shows an em dash. */
export function salaryUSD(v: number | null | undefined): string {
  return formatCurrency0(v, '—')
}

export function avg3(v: number | null | undefined): string {
  if (v == null) return '—'
  return v.toFixed(3).replace(/^0\./, '.')
}

export function heightFt(inches: number | null | undefined): string {
  if (inches == null) return '—'
  const ft = Math.floor(inches / 12)
  const inch = inches % 12
  return `${ft}'${inch}"`
}

export function weightLb(v: number | null | undefined): string {
  return v == null ? '—' : `${v} lb`
}

export function experienceLabel(years: number | null | undefined): string {
  if (years == null) return '—'
  if (years === 0) return 'Rookie'
  return `${years} year${years > 1 ? 's' : ''}`
}
